export default __webpack_public_path__ + "static/media/cladding3.5f2cc0de.jpeg";